/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './NavigationContainer.scss';

import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import NavigationRoutes from './NavigationRoutes';
import { routerConfig } from './NavigationConfig';
import PageLoadingContainer from './PageLoadingContainer';

const NavigationContainer = ({
  hasDataError = false,
  hasError = false,
  location
}) => {
  const { name = '', requestStates = [] } =
    routerConfig.find((config) => config.path === location.pathname) || {};
  return (
    <Fragment>
      <div className="navigation-component-container">
        <PageLoadingContainer
          hasDataError={hasDataError}
          hasError={hasError}
          name={name}
          requestStates={requestStates}>
          <NavigationRoutes config={routerConfig} />
        </PageLoadingContainer>
      </div>
    </Fragment>
  );
};

NavigationContainer.propTypes = {
  hasError: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(NavigationContainer);
